import { render, staticRenderFns } from "./securityOrder.vue?vue&type=template&id=1d5e571f&scoped=true"
import script from "./securityOrder.vue?vue&type=script&lang=js"
export * from "./securityOrder.vue?vue&type=script&lang=js"
import style0 from "./securityOrder.vue?vue&type=style&index=0&id=1d5e571f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e571f",
  null
  
)

export default component.exports